function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_876",
  "data-name": "Group 876",
  transform: "translate(-137 -713)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_494",
  "data-name": "Rectangle 494",
  transform: "translate(137 713)",
  fill: "none",
  stroke: "#898989",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  rx: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 13,
  height: 13,
  rx: 2.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_865",
  "data-name": "Group 865",
  transform: "translate(140.792 716.791)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_48",
  "data-name": "Line 48",
  x2: 6.417,
  transform: "translate(3.208) rotate(90)",
  fill: "none",
  stroke: "#898989",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_49",
  "data-name": "Line 49",
  x2: 6.417,
  transform: "translate(0 3.208)",
  fill: "none",
  stroke: "#898989",
  strokeWidth: 1.5
})));

var SvgIosAdd = function SvgIosAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIosAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ios_add.ea62bb76.svg";
export { ForwardRef as ReactComponent };